"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContractInstance = void 0;
const constants_1 = require("./constants");
const index_1 = require("../contracts/lsd/index");
const index_2 = require("../contracts/stakehouse/index");
const getContractInstance = (signer) => __awaiter(void 0, void 0, void 0, function* () {
    const chainID = yield (0, constants_1._extractChainID)(signer);
    const values = (0, constants_1._getChainSpecificConstants)(chainID);
    const getLSDNFactory = () => index_1.Lsdn_factory_abi__factory.connect(values === null || values === void 0 ? void 0 : values.factoryAddresses.LSDN_FACTORY, signer);
    const getLiquidStakingManager = (liquidStakingManagerAddress) => index_1.Lsm_abi__factory.connect(liquidStakingManagerAddress, signer);
    const getSavETHVault = (savETHVaultAddress) => index_1.Protected_staking_abi__factory.connect(savETHVaultAddress, signer);
    const getFeesAndMevPool = (feesAndMevPoolAddress) => index_1.Fees_and_mev_abi__factory.connect(feesAndMevPoolAddress, signer);
    const getGiantSavETHPool = () => index_1.Giant_protected_staking_abi__factory.connect(values === null || values === void 0 ? void 0 : values.factoryAddresses.GIANT_SAVETH_POOL, signer);
    const getGiantFeesAndMevPool = () => index_1.Giant_fees_and_mev_abi__factory.connect(values === null || values === void 0 ? void 0 : values.factoryAddresses.GIANT_FEES_AND_MEV_POOL, signer);
    const getSyndicate = (syndicateAddress) => index_1.Syndicate_abi__factory.connect(syndicateAddress, signer);
    const getSmartWallet = (smartWalletAddress) => index_1.Smart_wallet_abi__factory.connect(smartWalletAddress, signer);
    const getSmartWalletNamingRegistry = () => index_1.Smart_wallet_naming_abi__factory.connect(values === null || values === void 0 ? void 0 : values.factoryAddresses.SMART_WALLET_NAMING_REGISTRY, signer);
    const getDETH = () => index_2.Erc20_generic_abi__factory.connect(values === null || values === void 0 ? void 0 : values.factoryAddresses.DETH, signer);
    const getERC20 = (erc20Address) => index_2.Erc20_generic_abi__factory.connect(erc20Address, signer);
    const getRageQuitAssistant = (rageQuitAssistantAddress) => index_1.Rage_quit_assistant_abi__factory.connect(rageQuitAssistantAddress, signer);
    const getFrenDelegationBribeVault = (frenDelegationBribeVaultAddress) => index_1.Fren_delegation_bribes_abi__factory.connect(frenDelegationBribeVaultAddress, signer);
    const getZEC = () => index_1.Zec_abi__factory.connect(values === null || values === void 0 ? void 0 : values.factoryAddresses.ZEC, signer);
    return {
        lsdnFactory: getLSDNFactory,
        liquidStakingManager: getLiquidStakingManager,
        savETHVault: getSavETHVault,
        feesAndMevPool: getFeesAndMevPool,
        giantSavETHPool: getGiantSavETHPool,
        giantFeesAndMevPool: getGiantFeesAndMevPool,
        syndicate: getSyndicate,
        smartWallet: getSmartWallet,
        smartWalletNamingRegistry: getSmartWalletNamingRegistry,
        dETH: getDETH,
        erc20: getERC20,
        frenDelegationBribeVault: getFrenDelegationBribeVault,
        rageQuitAssistant: getRageQuitAssistant,
        zec: getZEC
    };
});
exports.getContractInstance = getContractInstance;
